export default __webpack_public_path__ + "static/media/calenderImg.636eda53.svg";